import { useState } from 'react';

export default function LearningSection({ data }) {
  const [endIdx, setEndIdx] = useState(4);
  return (
    <>
      <h1 className="mt-[55px] mb-[30px]  w-full text-lg font-bold md:text-2xl">
        What You will do After Learning
      </h1>
      <div className="grid grid-cols-2 gap-2 md:mx-8 md:grid-cols-3 lg:grid-cols-4 ">
        {data?.slice(0, endIdx)?.map((item) => (
          <div className="flex content-center items-center rounded-lg border-2 border-[#3AF4D3] p-2 text-[12px] font-semibold text-[#5A5A5A] transition duration-150 ease-in-out hover:scale-105  ">
            <img
              src="https://assets.learntube.ai/files/skill_page/checkbox.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1656676597252"
              alt="icon"
              srcset=""
              className="h-[16px] w-[16px]"
              width={16}
              height={16}
            />
            <span className="pl-2">{item[1]=="." ? item?.slice(2) :item}</span>
          </div>
        ))}
      </div>
      {/* <button
        className=" mx-auto mt-1 rounded-3xl border-2 px-3 py-1 text-xs shadow-md md:text-base"
        onClick={() => {
          if (endIdx >= data.length) {
            setEndIdx(4);
          } else {
            setEndIdx((prevIdx) => Math.min(prevIdx + 4, data.length));
          }
        }}
      >
        {endIdx >= data.length
          ? data.length === 4
            ? ''
            : '- Hide'
          : '+4 more'}
      </button> */}
    </>
  );
}
